import inventory from '@/api/stock/inventory-list'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'
import { mapKeys, camelCase } from 'lodash'

class SummaryPagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

import _ from 'lodash'

export const state = {
  ...baseState,
  location_id: [],
  branch_id: [],
  category_id: [],
  location_id_summary: [],
  category_id_summary: [],
  branch_id_summary: [],
  summaryResources: [],
  summaryPagination: new SummaryPagination(),
  dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')],
  asOfDate: moment().format('DD-MM-YYYY'),
  product_categories: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES_SUMMARY(state, { data, ...meta }) {
    state.summaryResources = []
    data.forEach(resource => {
      state.summaryResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.summaryPagination = new SummaryPagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_AS_OF_DATE(state, date) {
    state.asOfDate = date
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_LOCATION_ID_SUMMARY(state, value) {
    state.location_id_summary = value
  },
  SET_BRANCH_ID_SUMMARY(state, value) {
    state.branch_id_summary = value
  },
  SET_CATEGORY_ID(state, value) {
    state.category_id = value
  },
  SET_CATEGORY_ID_SUMMARY(state, value) {
    state.category_id_summary = value
  },
  RESET_SUMMARY_RESOURCES(state) {
    state.summaryResources = []
    state.summaryPagination = new SummaryPagination()
  },
  SET_PRODUT_CATEGORY(state, data) {
    state.product_categories = data.map(el => ({
      value: el.category_id,
      label: el.category_name_en
    }))
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        category_id: context.state.category_id,
        location_id: context.state.location_id,
        branch_id: _.join(context.state.branch_id, ','),
        date_from: context.state.dateRange[0],
        date_to: context.state.dateRange[1],

      },
      attrubutes
    )
    return inventory.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  fetchSummary(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.summaryPagination.page,
        perPage: context.state.summaryPagination.perPage,
        category_id: context.state.category_id_summary,
        location_id: context.state.location_id_summary,
        branch_id: _.join(context.state.branch_id_summary, ','),
        date_to: context.state.asOfDate,

      },
      attrubutes
    )
    return inventory.getSummary({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_SUMMARY', response)
      return Promise.resolve(response)
    })
  },
  async getProductCategory(context, attribute = {}) {
    let response = await inventory.productCategory()
    context.commit('SET_PRODUT_CATEGORY', response.data)
    return response
  },
  refreshStock(context, data) {
    return inventory.refreshStock(data)
  },
  refreshCurrentStock(context, data) {
    return inventory.refreshCurrentStock(data)
  },
  refreshDailyStock(context, data) {
    return inventory.refreshDailyStock(data)
  },
  refreshStockByDuration(context, data) {
    return inventory.refreshStockByDuration(data)
  }
}
